import { Box, styled } from '@mui/material'

export const FieldsWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    width: '35%',
    flexDirection: 'column',
    gap: '20px',
    [theme.breakpoints.down('md')]: {
        width: '100%',
    },
}))
